export function LoadingScreen() {
  return (
    <div className="flex items-center justify-center h-screen bg-slate-100 dark:bg-slate-900">
      <div className="text-xl text-slate-600 dark:text-slate-400 animate-pulse">Memuat...</div>
    </div>
  );
}

export const FormLoadingFallback = () => (
  <div className="min-h-screen bg-slate-100 dark:bg-slate-900 flex flex-col items-center justify-center p-4">
    <div className="w-full max-w-lg bg-white dark:bg-slate-800 p-6 rounded-lg shadow-md animate-pulse">
      <div className="h-48 bg-slate-200 dark:bg-slate-700 rounded-md mb-4"></div>
      <div className="h-8 bg-slate-200 dark:bg-slate-700 rounded w-3/4 mb-4"></div>
      <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-full mb-2"></div>
      <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-5/6 mb-6"></div>
      <div className="space-y-3">
        <div className="h-10 bg-slate-200 dark:bg-slate-700 rounded"></div>
        <div className="h-10 bg-slate-200 dark:bg-slate-700 rounded"></div>
      </div>
    </div>
  </div>
);
